<ul class="portfolio-cards" color="secondary">
  <div class="filters-panel">
    <section class="filters-group filters-group--categories" aria-labelledby="category-filters-label">
      <div class="filters-group-label" id="category-filters-label">Categories</div>
      <div class="filters-chip-wrap">
        <mat-chip-listbox class="listbox" multiple aria-labelledby="category-filters-label">
          @for (filter of categoryOptions; track filter) {
            <mat-chip-option
              (click)="toggleCategoryFilter(filter)"
              [selected]="filterIsSelectedCategory(filter)"
            >
              {{ filter }}
            </mat-chip-option>
          }
        </mat-chip-listbox>
      </div>
    </section>

    <section class="filters-group filters-group--status" aria-labelledby="status-filters-label">
      <div class="filters-group-label" id="status-filters-label">Status</div>
      <div class="filters-chip-wrap">
        <mat-chip-listbox class="listbox" multiple aria-labelledby="status-filters-label">
          @for (filter of statusOptions; track filter) {
            <mat-chip-option
              (click)="toggleStatusTagFilter(filter)"
              [selected]="filterIsSelectedStatusTag(filter)"
            >
              {{ filter }}
            </mat-chip-option>
          }
        </mat-chip-listbox>
      </div>
    </section>

    @if (tagFilterOptions.length > 0) {
      <section class="filters-group filters-group--tags" aria-labelledby="tag-filters-label">
        <div class="filters-group-label" id="tag-filters-label">Tags</div>
        <div class="filters-chip-wrap">
          <mat-chip-listbox class="listbox" multiple aria-labelledby="tag-filters-label">
            @for (filter of tagFilterOptions; track filter) {
              <mat-chip-option
                (click)="toggleStatusTagFilter(filter)"
                [selected]="filterIsSelectedStatusTag(filter)"
              >
                {{ filter }}
              </mat-chip-option>
            }
          </mat-chip-listbox>
        </div>
      </section>
    }
  </div>

  @for (project of this.projects; track project.id) {
    <div class="project-card-wrapper">
      <project-card
        [project]="project"
        [selectedCategoryFilters]="selectedCategoryFilters"
        [selectedStatusTagFilters]="selectedStatusTagFilters"
        [showPrivateBadge]="showPrivateBadge"
        (categoryFilterEvent)="toggleCategoryFilter($event)"
        (statusTagFilterEvent)="toggleStatusTagFilter($event)"
      ></project-card>
    </div>
  }
</ul>
